import { Component, OnInit, DestroyRef, inject } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { NgbAlert } from '@ng-bootstrap/ng-bootstrap';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-hydra-error-page',
    templateUrl: './hydra-error-page.component.html',
    styleUrls: ['./hydra-error-page.component.scss'],
    imports: [NgbAlert]
})
export class HydraErrorPageComponent implements OnInit {
  public error: string;
  public errorMessage: string;
  private destroyRef = inject(DestroyRef);

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.queryParams
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((params: Params) => {
        this.error = params.error;
        this.errorMessage = params.error_description;
      });
  }

}
